import { TmFormError } from '@/core/error/tmFormError'

export class TmFormValidationError extends TmFormError {
  public name = 'TmFormValidationError'

  protected isMonitored = false
}
